import {
  defaultLocale,
  getMessagesForLocale,
  isSupportedLocale,
  type PortalLocale,
} from "@/lib/i18n/portal";

/**
 * Translate outside of React. The intl provider mirrors the active locale onto
 * `<html lang>`, so non-React callers (e.g. the React Query client's global
 * error handler) can resolve messages without the `useTranslations` hook.
 *
 * `key` is a dotted path (the same string the `keys` object yields, e.g.
 * `keys.errors.generic === "errors.generic"`). Falls back to the key itself if
 * the message is missing.
 */
function currentLocale(): PortalLocale {
  const lang =
    typeof document !== "undefined" ? document.documentElement.lang : "";
  return isSupportedLocale(lang) ? lang : defaultLocale;
}

export function translateStandalone(key: string): string {
  const messages = getMessagesForLocale(currentLocale()) as Record<string, unknown>;
  const value = key.split(".").reduce<unknown>((current, segment) => {
    if (!current || typeof current !== "object") return undefined;
    return (current as Record<string, unknown>)[segment];
  }, messages);
  return typeof value === "string" ? value : key;
}
